import { render } from "./ProgrammiUser.vue?vue&type=template&id=36ef0fbe&scoped=true"
import script from "./ProgrammiUser.vue?vue&type=script&lang=js"
export * from "./ProgrammiUser.vue?vue&type=script&lang=js"

import "./ProgrammiUser.vue?vue&type=style&index=0&id=36ef0fbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ef0fbe"]])

export default __exports__